import { connect } from 'react-redux';
import { actions } from '../../../../redux/modules/compras/liquidacionBonos';
import Liquidacion from './LiquidacionBonosFormTabs';


const ms2p = (state) => {
  return {
    ...state.liqBono,
  };
};

const md2p = { ...actions };

export default connect(ms2p, md2p)(Liquidacion);
